<template>
  <div class="about-page">
    <!-- Logo容器 -->
    <div class="logo-container">
      <img
        src="@/assets/logo.png"
        alt="网站Logo"
        class="logo" />
    </div>
    <!-- 介绍文字 -->
    <div class="content">
      <p class="description">
        宁波开发者技术交流社区，让有意思的人聚在一起。
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useHead } from '@vueuse/head'
const SSRData = ref({
  title: '关于 - 默认代码',
  description: '默认代码,defaultcode.com 是宁波的开发者技术社区，为开发者提供纯粹、高质的技术交流平台，让有意思的人聚在一起。',
  keywords: '默认代码,默认代码社区,宁波技术社区,宁波开发者技术交流社区,程序员中文技术社区'
})
// 使用组合式 API 设置 head
useHead({
  title: SSRData.value.title,
  meta: [
    { name: 'description', content: SSRData.value.description },
    { name: 'keywords', content: SSRData.value.keywords }
  ]
})
</script>

<style scoped>
.about-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 12rem;
  min-height: 100vh;
}

.logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2rem 0;
}

.logo {
  width: 180px; /* 根据实际logo尺寸调整 */
  height: auto;
  transition: transform 0.3s ease;
}

.logo:hover {
  transform: scale(1.05);
}

.content {
  text-align: center;
  padding: 0 1rem;
}

.title {
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 1.5rem;
  font-weight: 600;
}

.description {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #666;
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  text-indent: 2em;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .logo {
    width: 120px;
  }

  .title {
    font-size: 2rem;
  }

  .description {
    font-size: 1rem;
    padding: 0 10px;
  }
}
</style>
